
import { z } from "zod";

export const AddressKeySchemeValues = ["SMARTY_KEY", "CANONICAL_V1"] as const;
export const AddressKeySchemeSchema = z.enum(AddressKeySchemeValues);
export const AddressKeyScheme = AddressKeySchemeSchema.enum;
export type AddressKeyScheme = (typeof AddressKeySchemeValues)[number];
